var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAtivo3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508.09 422.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#fff;}.cls-18,.cls-2{opacity:0.5;}.cls-3{fill:#7dc3ea;}.cls-4{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_3);}.cls-5{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_10);}.cls-6{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13);}.cls-7{fill:#396caa;}.cls-8{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13-2);}.cls-9{fill:#d4ecff;}.cls-10{fill:#5793ce;}.cls-11{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_45);}.cls-12,.cls-18{fill:#173d7a;}.cls-13{fill:#274f89;}.cls-14{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_59);}.cls-15{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_70);}.cls-16{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_59-2);}.cls-17{fill:#ff2c9c;}.cls-19{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13-3);}.cls-20{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13-4);}.cls-21{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13-5);}.cls-22{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13-6);}.cls-23{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_13-7);}.cls-24{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_10-2);}.cls-25{fill:url(#\xC1\xE5\xE7\xFB\xEC\xFF\xED\xED\xFB\xE9_\xE3\xF0\xE0\xE4\xE8\xE5\xED\xF2_70-2);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_3",
    cx: 472.38,
    cy: 164.45,
    r: 45.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#274f89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#173d7a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_10",
    x1: 444.77,
    y1: 147.96,
    x2: 525.21,
    y2: 147.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4ecff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#d0eafe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#c5e2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#b2d6f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#98c4e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#86b8e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13",
    cx: 407.03,
    cy: 117.41,
    r: 82.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#699dd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#6396cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#5184bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#396caa"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13-2",
    cx: 9.55,
    cy: 287.72,
    r: 53.19,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_45",
    x1: 19.59,
    y1: 270.67,
    x2: 102.9,
    y2: 320.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4ecff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d0eafe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#c5e2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#b2d6f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#98c4e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#86b8e0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_59",
    cx: 431.57,
    cy: 244.28,
    r: 272.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#86b8e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#98c4e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#b2d6f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#c5e2f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#d0eafe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4ecff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_70",
    cx: 410,
    cy: 182.74,
    r: 187.39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#173d7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#274f89"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_59-2",
    cx: 438.98,
    cy: 265.24,
    r: 369.57,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_59"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13-3",
    cx: 175.27,
    cy: 201.26,
    r: 17.19,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13-4",
    cx: 165.66,
    cy: 182.81,
    r: 27.18,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13-5",
    cx: 233.07,
    cy: 234.67,
    r: 17.19,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13-6",
    cx: 223.46,
    cy: 216.22,
    r: 27.18,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13-7",
    cx: 249.16,
    cy: 120.91,
    r: 97.82,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_10-2",
    x1: 118.37,
    y1: 128.92,
    x2: 315.94,
    y2: 128.92,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_70-2",
    cx: 309.35,
    cy: 202.73,
    r: 197.8,
    xlinkHref: "#\\xC1\\xE5\\xE7\\xFB\\xEC\\xFF\\xED\\xED\\xFB\\xE9_\\xE3\\xF0\\xE0\\xE4\\xE8\\xE5\\xED\\xF2_70"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M344,364.9a9,9,0,0,1-4.07,7c-2.24,1.29-4.06.24-4.06-2.35a9,9,0,0,1,4.06-7C342.14,361.26,344,362.31,344,364.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.12,357.3a9,9,0,0,1-4.06,7c-2.24,1.29-4.06.24-4.06-2.35a9,9,0,0,1,4.06-7C355.3,353.66,357.12,354.71,357.12,357.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M370.29,349.7a9,9,0,0,1-4.06,7c-2.25,1.3-4.07.25-4.07-2.34a9,9,0,0,1,4.07-7C368.47,346.06,370.29,347.11,370.29,349.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.45,342.1a9,9,0,0,1-4.06,7c-2.24,1.3-4.06.25-4.06-2.34a9,9,0,0,1,4.06-7C381.63,338.46,383.45,339.51,383.45,342.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "7.12 266.07 0 270.18 0 261.96 7.12 257.86 7.12 266.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.65 259.41 11.54 263.52 11.54 255.3 18.65 251.19 18.65 259.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "30.19 252.75 23.07 256.86 23.07 248.64 30.19 244.53 30.19 252.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "41.73 246.09 34.61 250.2 34.61 241.98 41.73 237.87 41.73 246.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "129.01 360.92 120.89 365.61 120.89 356.23 129.01 351.54 129.01 360.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.28 354.33 132.16 359.02 132.16 349.64 140.28 344.95 140.28 354.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "129.08 373.09 120.96 377.78 120.96 368.4 129.08 363.71 129.08 373.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "140.28 366.62 132.16 371.31 132.16 361.93 140.28 357.24 140.28 366.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M216.37,373.06A13.2,13.2,0,0,0,213,376c-.16-6.64-4.93-9.29-10.8-5.9a19.56,19.56,0,0,0-5.18,4.52c-2.62-4.56-8-5.63-14.3-2-8.83,5.09-16,17.48-16,27.66a19.8,19.8,0,0,0,.16,2.38,6,6,0,0,0-4.47.91,16.87,16.87,0,0,0-7.64,13.23c0,4.88,3.42,6.85,7.64,4.42L216.37,390a16.25,16.25,0,0,0,7.35-12.73C223.72,372.61,220.43,370.71,216.37,373.06Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "475.27 227.77 444.77 210.16 475.27 192.55 505.77 210.16 475.27 227.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M475.27,216.86a2.29,2.29,0,0,1-1.16-.31l-30.5-17.61a2.31,2.31,0,0,1,0-4l30.5-17.61a2.29,2.29,0,0,1,2.32,0l30.5,17.61a2.31,2.31,0,0,1,0,4l-30.5,17.61A2.29,2.29,0,0,1,475.27,216.86ZM449.4,196.94l25.87,14.93,25.86-14.93L475.27,182Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "505.77 183.18 475.27 200.78 475.27 165.57 505.77 147.96 505.77 183.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "475.27 165.57 444.77 147.96 475.27 130.35 505.77 147.96 475.27 165.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "475.27 200.78 444.77 183.18 444.77 147.96 475.27 165.57 475.27 200.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "464.28 181.76 455.75 176.83 455.75 166.98 464.28 171.91 464.28 181.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M50.69,361.86,8.62,337.57c-2.59-1.49-2.26-4.09.72-5.82L50,308.3c3-1.73,7.49-1.91,10.08-.42l42.07,24.29c2.58,1.49,2.26,4.1-.72,5.82L60.77,361.45C57.79,363.17,53.28,363.36,50.69,361.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.09,352a11.28,11.28,0,0,1-5.59-1.34L7.42,326.35a5.37,5.37,0,0,1-2.94-4.6c0-2.06,1.34-4,3.66-5.36l40.63-23.46c3.76-2.17,9.13-2.34,12.47-.42l42.08,24.3a5.37,5.37,0,0,1,2.94,4.59c0,2.07-1.34,4-3.67,5.36L62,350.22A13.91,13.91,0,0,1,55.09,352Zm-3.2-5.48c1.86,1.07,5.45.88,7.68-.42l40.63-23.46c1-.59,1.27-1.12,1.28-1.22a1.74,1.74,0,0,0-.55-.45l-42.08-24.3c-1.86-1.07-5.45-.87-7.69.42L10.53,320.53c-1,.59-1.26,1.12-1.27,1.22a1.56,1.56,0,0,0,.55.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M103.85,306.52h0V292L71.3,292l-11.25-6.5c-2.59-1.49-7.1-1.3-10.08.42L39.47,292l-32.58,0v14.94a2.91,2.91,0,0,0,1.73,2.7l42.07,24.29c2.59,1.49,7.1,1.3,10.08-.42L101.4,310C103.12,309,104,307.71,103.85,306.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M55.37,284.49A11.6,11.6,0,0,0,50,285.9L39.47,292l-32.58,0v14.94a2.91,2.91,0,0,0,1.73,2.7l42.07,24.29a9.14,9.14,0,0,0,4.68,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M10.57,292H6.89v14.94a2.91,2.91,0,0,0,1.73,2.7l2,1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M51.34,334.19a11.48,11.48,0,0,0,8.06-.1V317.14H51.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M50.69,319,8.62,294.7c-2.59-1.49-2.26-4.1.72-5.82L50,265.42c3-1.72,7.49-1.9,10.08-.41l42.07,24.29c2.58,1.49,2.26,4.09-.72,5.82L60.77,318.57C57.79,320.3,53.28,320.48,50.69,319Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.4,292.26,60.77,315.72c-3,1.72-7.49,1.91-10.08.41L8.62,291.84a3.84,3.84,0,0,1-1.29-1.14c-.89,1.43-.49,3,1.29,4L50.69,319c2.59,1.49,7.1,1.31,10.08-.42l40.63-23.45c2.32-1.34,3-3.21,2-4.68A5.64,5.64,0,0,1,101.4,292.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M88.38,310.35a3.75,3.75,0,0,1-1.7,2.94c-.94.54-1.7.1-1.7-1a3.75,3.75,0,0,1,1.7-2.94C87.62,308.83,88.38,309.26,88.38,310.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M93.84,307.19a3.77,3.77,0,0,1-1.7,2.95c-.93.54-1.7.1-1.7-1a3.78,3.78,0,0,1,1.7-2.94C93.08,305.67,93.84,306.11,93.84,307.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M99.31,304a3.75,3.75,0,0,1-1.7,3c-.94.54-1.7.1-1.7-1a3.77,3.77,0,0,1,1.7-2.95C98.55,302.51,99.31,303,99.31,304Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M53.18,303.93,33.49,292.56c-1.21-.7-1.05-1.91.34-2.72l19-11a5.26,5.26,0,0,1,4.72-.19L77.25,290c1.21.69,1.06,1.91-.34,2.72l-19,11A5.23,5.23,0,0,1,53.18,303.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M55.07,294.41l-2.73-1.57c-.16-.1-.14-.27,0-.38L55,290.94a.71.71,0,0,1,.65,0l2.73,1.57c.16.1.14.26,0,.38l-2.63,1.51A.69.69,0,0,1,55.07,294.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M33.49,292.56l.06,0c.09-.06.17-.13.28-.19l19-11a5.26,5.26,0,0,1,4.72-.19l19.63,11.33c1.12-.79,1.17-1.88.06-2.52L57.56,278.67a5.26,5.26,0,0,0-4.72.19l-19,11C32.44,290.65,32.28,291.86,33.49,292.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M122.32,161.51A14.5,14.5,0,0,0,120,163.2c-.31-10.36-7.8-14.48-17-9.17-7.5,4.33-13.86,13.6-16.13,22.69a10.17,10.17,0,0,0-6.37,1.58c-6.71,3.87-12.15,13.3-12.15,21s5.44,10.89,12.15,7l41.81-24.14c5-2.86,9-9.82,9-15.54S127.27,158.65,122.32,161.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M472.57,14.85a15.22,15.22,0,0,0-3.85,3.31c-.18-7.6-5.62-10.63-12.33-6.76a22.45,22.45,0,0,0-5.93,5.18c-3-5.22-9.17-6.43-16.34-2.29-10.09,5.82-18.26,20-18.26,31.61a23.61,23.61,0,0,0,.18,2.73,6.81,6.81,0,0,0-5.11,1c-4.82,2.78-8.73,9.56-8.73,15.13s3.91,7.82,8.73,5l61.64-35.59c4.64-2.68,8.4-9.19,8.4-14.55S477.21,12.17,472.57,14.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M430.05,276.15a2,2,0,0,1-.94-.24,2,2,0,0,1-.87-2.76,23,23,0,0,1,8.37-9.2,10.77,10.77,0,0,1,5.9-1.64h.25c2.59,0,5.76-2,8.54-5.32a20.11,20.11,0,0,1,5.32-4.61,10.78,10.78,0,0,1,5.9-1.63c2.59.17,5.93-1.85,8.8-5.31a20.5,20.5,0,0,1,5.32-4.62,10.8,10.8,0,0,1,5.9-1.63c2.57.18,5.92-1.85,8.79-5.31a20.11,20.11,0,0,1,5.33-4.61c3-1.74,6-2.11,8.43-1.05a2,2,0,0,1-1.63,3.76c-1.22-.54-2.91-.24-4.76.83a16.6,16.6,0,0,0-4.22,3.69c-3.74,4.51-8.2,7-12.15,6.78a6.84,6.84,0,0,0-3.64,1.09,16.22,16.22,0,0,0-4.22,3.68c-3.74,4.51-8.16,7-12.15,6.79a6.72,6.72,0,0,0-3.65,1.09,16.35,16.35,0,0,0-4.22,3.68c-3.74,4.51-8.21,7-12.15,6.79a6.6,6.6,0,0,0-3.64,1.08,18.91,18.91,0,0,0-6.79,7.56A2,2,0,0,1,430.05,276.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M262.62,378.57,94.87,281.72C90.13,279,90.72,274.19,96.2,271L210.43,205.1c5.48-3.16,13.77-3.51,18.51-.77l167.75,96.86c4.75,2.74,4.15,7.52-1.33,10.68L281.14,377.8C275.66,381,267.37,381.31,262.62,378.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.68,363.86a18.25,18.25,0,0,1-9-2.12L93.89,264.89c-2.7-1.55-4.19-3.81-4.19-6.34,0-2.9,2-5.73,5.52-7.75l114.23-65.93c6.11-3.53,15.11-3.86,20.47-.76L397.67,281c2.7,1.56,4.19,3.81,4.19,6.34,0,2.9-2,5.73-5.51,7.75L282.12,361A23.42,23.42,0,0,1,270.68,363.86Zm-7.07-5.52c4.12,2.38,11.7,2,16.55-.77l114.22-65.92c2.22-1.29,3.55-2.91,3.55-4.35s-1.21-2.35-2.22-2.94L228,187.51c-4.13-2.38-11.7-2-16.55.77L97.18,254.2c-2.22,1.29-3.54,2.91-3.54,4.35s1.2,2.35,2.22,2.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M438.3,97.89,270.55,1a6.77,6.77,0,0,0-5.69-.7v0l-.3.12-.07,0-6.07,2.32,5.44,2.66c0,.1-.05.19-.07.3L234.16,140.54c-1.37,6.23,1.37,13.49,6.11,16.23L404,251.29l-.59,6.94,6.63-2.57c2.23-1,4-3.39,4.75-6.75l29.64-134.79C445.78,107.89,443,100.63,438.3,97.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M438.3,97.89,270.55,1a6.77,6.77,0,0,0-5.69-.7v0l-.3.12-.07,0-6.07,2.32,5.44,2.66c0,.1-.05.19-.07.3L243.47,98.14l82.08,63.94L443.6,104.57A13,13,0,0,0,438.3,97.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M432,117l12.77-5.44c.24-4.95-1.81-10-5.17-12.79l-20.21,8.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M397.58,257.57,229.83,160.72c-4.75-2.74-7.49-10-6.12-16.23L253.35,9.69c1.37-6.22,6.32-9,11.07-6.3l167.75,96.85c4.74,2.74,7.48,10,6.12,16.23L408.64,251.26C407.28,257.49,402.32,260.31,397.58,257.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M433.78,99.65,266,2.8a6.63,6.63,0,0,0-6.61-.29,6.89,6.89,0,0,1,5,.88l167.75,96.85c4.74,2.74,7.48,10,6.12,16.23L408.64,251.26a9.46,9.46,0,0,1-4.46,6.6c2.83-.62,5.2-3.19,6.08-7.19L439.9,115.88C441.26,109.65,438.52,102.39,433.78,99.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M393.94,248.32l-157.77-91c-4.34-2.51-6.84-9.16-5.59-14.85L257.9,18.19c1.25-5.69,5.78-8.28,10.13-5.77l157.76,91c4.34,2.51,6.85,9.16,5.6,14.85L404.07,242.55C402.82,248.24,398.28,250.83,393.94,248.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M393.94,248.32l-157.77-91c-4.34-2.51-6.84-9.16-5.59-14.85L257.9,18.19c1.25-5.69,5.78-8.28,10.13-5.77l157.76,91c4.34,2.51,6.85,9.16,5.6,14.85L404.07,242.55C402.82,248.24,398.28,250.83,393.94,248.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M395.32,247.76l-157.77-91c-4.34-2.51-6.85-9.16-5.6-14.85L259.27,17.63a8.74,8.74,0,0,1,4-6c-2.5.65-4.57,3-5.35,6.55L230.58,142.43c-1.25,5.69,1.25,12.34,5.59,14.85l157.77,91a6.05,6.05,0,0,0,6.15.22A6.3,6.3,0,0,1,395.32,247.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M399.89,261.79l-22.93-3-148-85.46c-4.74-2.74-13-2.39-18.51.77L105.54,234.6l-13.86-1.83v7.87h0c-.09,1.82.94,3.57,3.18,4.86l167.75,96.85c4.75,2.74,13,2.4,18.52-.76l114.22-65.93c3.09-1.78,4.62-4.07,4.53-6.23h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M288.68,207.79l-10.52-6.07H162.54l-57,32.88-13.86-1.83v7.87h0c-.09,1.82.94,3.57,3.18,4.86l167.75,96.85a17.32,17.32,0,0,0,9.56,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M97.83,233.59l-6.15-.82v7.87h0c-.09,1.82.94,3.57,3.18,4.86l3,1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M264.31,343.14c4.5,1.7,10.93,1.33,15.73-1V324.61H264.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M262.62,334.5,94.87,237.64c-4.74-2.74-4.15-7.52,1.33-10.68L210.43,161c5.48-3.16,13.77-3.51,18.51-.77l167.75,96.85c4.75,2.74,4.15,7.53-1.33,10.69L281.14,333.73C275.66,336.89,267.37,337.23,262.62,334.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M395.36,264.93,281.14,330.85c-5.48,3.17-13.77,3.51-18.52.77L94.87,234.77a6.3,6.3,0,0,1-3-3.23c-.74,2.25.21,4.52,3,6.1l167.75,96.85c4.75,2.75,13,2.4,18.52-.76L395.36,267.8c3.69-2.13,5.15-5,4.28-7.46A8.92,8.92,0,0,1,395.36,264.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M166.22,205.58l-7.59-4.38c-.61-.35-.53-1,.17-1.37l9-5.18a2.64,2.64,0,0,1,2.38-.09l7.59,4.38c.61.35.53,1-.17,1.37l-9,5.17A2.64,2.64,0,0,1,166.22,205.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M177.94,212.35,170.35,208c-.61-.36-.53-1,.17-1.38l9-5.17a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.36.53,1-.17,1.38l-9,5.17A2.64,2.64,0,0,1,177.94,212.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M189.66,219.12l-7.59-4.39c-.61-.35-.53-1,.17-1.37l9-5.17a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.35.53,1-.17,1.37L192,219A2.67,2.67,0,0,1,189.66,219.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M205.87,213.53l-7.59-4.39c-.61-.35-.53-1,.17-1.37l7.52-4.34a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.36.54,1-.17,1.38l-7.52,4.34A2.67,2.67,0,0,1,205.87,213.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M217.59,220.29,210,215.91c-.6-.35-.53-1,.18-1.37l7.52-4.34a2.62,2.62,0,0,1,2.37-.1l7.59,4.38c.61.35.54,1-.17,1.37L220,220.2A2.64,2.64,0,0,1,217.59,220.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M229.32,227.06l-7.59-4.38c-.61-.35-.54-1,.17-1.37l7.52-4.35a2.62,2.62,0,0,1,2.37-.09l7.59,4.38c.61.35.54,1-.17,1.37L231.69,227A2.62,2.62,0,0,1,229.32,227.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M241,233.83l-7.59-4.38c-.61-.36-.54-1,.17-1.38l7.52-4.34a2.67,2.67,0,0,1,2.38-.1l7.59,4.39c.61.35.53,1-.17,1.37l-7.53,4.34A2.62,2.62,0,0,1,241,233.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M252.76,240.6l-7.59-4.39c-.61-.35-.53-1,.17-1.37l7.52-4.34a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.35.53,1-.17,1.38l-7.52,4.34A2.67,2.67,0,0,1,252.76,240.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M264.48,247.36,256.89,243c-.61-.35-.53-1,.17-1.37l7.52-4.34a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.35.53,1-.17,1.37l-7.52,4.34A2.61,2.61,0,0,1,264.48,247.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M276.2,254.13l-7.59-4.38c-.61-.35-.53-1,.17-1.37L276.3,244a2.64,2.64,0,0,1,2.38-.09l7.59,4.38c.61.35.53,1-.17,1.37L278.58,254A2.64,2.64,0,0,1,276.2,254.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M287.92,260.9l-7.59-4.38c-.61-.36-.53-1,.17-1.38L288,250.8a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.36.53,1-.17,1.38l-7.52,4.34A2.64,2.64,0,0,1,287.92,260.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M299.64,267.67l-7.59-4.39c-.61-.35-.53-1,.17-1.37l7.53-4.34a2.62,2.62,0,0,1,2.37-.1l7.59,4.38c.61.35.54,1-.17,1.37L302,267.57A2.67,2.67,0,0,1,299.64,267.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M311.37,274.43l-7.59-4.38c-.61-.35-.54-1,.17-1.37l7.52-4.34a2.62,2.62,0,0,1,2.37-.1l7.59,4.38c.61.35.54,1-.17,1.37l-7.52,4.34A2.62,2.62,0,0,1,311.37,274.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M223.14,210.32l-7.59-4.38c-.61-.35-.53-1,.17-1.37l7.53-4.34a2.62,2.62,0,0,1,2.37-.1l7.59,4.38c.61.35.54,1-.17,1.37l-7.52,4.34A2.64,2.64,0,0,1,223.14,210.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M211.25,203.45l-7.59-4.38c-.61-.35-.54-1,.17-1.37l7.52-4.34a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.35.53,1-.17,1.37l-7.52,4.35A2.64,2.64,0,0,1,211.25,203.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M199.33,196.57,183,187.14c-.61-.35-.54-1,.17-1.38l7.52-4.34a2.65,2.65,0,0,1,2.37-.1l16.35,9.44c.61.35.53,1-.17,1.37l-7.52,4.35A2.64,2.64,0,0,1,199.33,196.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M207.66,188.21l-13.26-7.66c-.61-.35-.54-1,.17-1.37l7.52-4.35a2.62,2.62,0,0,1,2.37-.09l13.27,7.66c.61.35.53,1-.17,1.37L210,188.11A2.64,2.64,0,0,1,207.66,188.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M234.87,217.09l-7.59-4.38c-.61-.35-.54-1,.17-1.37L235,207a2.65,2.65,0,0,1,2.37-.1l7.59,4.39c.61.35.54,1-.17,1.37L237.24,217A2.62,2.62,0,0,1,234.87,217.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M246.59,223.86,239,219.48c-.61-.36-.54-1,.17-1.38l7.52-4.34a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.6.36.53,1-.18,1.38L249,223.76A2.62,2.62,0,0,1,246.59,223.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M258.31,230.62l-7.59-4.38c-.61-.35-.54-1,.17-1.37l7.52-4.34a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.35.53,1-.17,1.37l-7.52,4.35A2.64,2.64,0,0,1,258.31,230.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M270,237.39,262.44,233c-.61-.35-.53-1,.17-1.37l7.52-4.34a2.61,2.61,0,0,1,2.38-.1l7.59,4.38c.61.35.53,1-.17,1.37l-7.52,4.34A2.64,2.64,0,0,1,270,237.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M281.75,244.16l-7.59-4.38c-.61-.35-.53-1,.17-1.38l7.52-4.34a2.67,2.67,0,0,1,2.38-.1l7.59,4.39c.61.35.53,1-.17,1.37l-7.52,4.34A2.64,2.64,0,0,1,281.75,244.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M293.47,250.93l-7.59-4.39c-.61-.35-.53-1,.17-1.37l7.52-4.34a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.36.53,1-.17,1.38l-7.52,4.34A2.67,2.67,0,0,1,293.47,250.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M305.19,257.69l-7.59-4.38c-.61-.35-.53-1,.17-1.37l7.52-4.34a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.35.54,1-.17,1.37l-7.52,4.35A2.64,2.64,0,0,1,305.19,257.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M316.91,264.46l-7.59-4.38c-.6-.35-.53-1,.18-1.37l7.52-4.35a2.62,2.62,0,0,1,2.37-.09l7.59,4.38c.61.35.54,1-.17,1.37l-7.52,4.34A2.64,2.64,0,0,1,316.91,264.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M328.64,271.23l-7.59-4.38c-.61-.36-.54-1,.17-1.38l7.52-4.34a2.65,2.65,0,0,1,2.37-.1l7.59,4.39c.61.35.54,1-.17,1.37L331,271.13A2.62,2.62,0,0,1,328.64,271.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M349.47,283.26l-16.56-9.56c-.61-.35-.53-1,.17-1.37L340.6,268a2.67,2.67,0,0,1,2.38-.1l16.56,9.57c.61.35.54,1-.17,1.37l-7.52,4.34A2.64,2.64,0,0,1,349.47,283.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M372.29,270.08l-14-8.07c-.61-.35-.54-1,.17-1.37L366,256.3a2.62,2.62,0,0,1,2.37-.1l14,8.07c.61.35.54,1-.17,1.37L374.67,270A2.64,2.64,0,0,1,372.29,270.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M255.39,215.77l-7.59-4.39c-.61-.35-.53-1,.17-1.37l7.52-4.34a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.35.53,1-.17,1.38l-7.52,4.34A2.67,2.67,0,0,1,255.39,215.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M243.38,208.83l-7.59-4.38c-.61-.35-.53-1,.17-1.37l7.52-4.35a2.67,2.67,0,0,1,2.38-.1l7.59,4.39c.61.35.53,1-.17,1.37l-7.52,4.34A2.64,2.64,0,0,1,243.38,208.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M231.37,201.89l-7.59-4.38c-.61-.35-.54-1,.17-1.37l7.52-4.34a2.62,2.62,0,0,1,2.37-.1l7.59,4.38c.61.35.54,1-.17,1.37l-7.52,4.35A2.62,2.62,0,0,1,231.37,201.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M219.35,195l-7.59-4.38c-.61-.35-.53-1,.17-1.38l7.52-4.34a2.67,2.67,0,0,1,2.38-.1l7.59,4.39c.61.35.53,1-.17,1.37l-7.52,4.34A2.64,2.64,0,0,1,219.35,195Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M267.11,222.53l-7.59-4.38c-.61-.35-.53-1,.17-1.37l7.52-4.34a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.35.53,1-.17,1.37l-7.52,4.34A2.61,2.61,0,0,1,267.11,222.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M278.83,229.3l-7.59-4.38c-.6-.35-.53-1,.18-1.37l7.52-4.35a2.62,2.62,0,0,1,2.37-.09l7.59,4.38c.61.35.54,1-.17,1.37l-7.52,4.34A2.64,2.64,0,0,1,278.83,229.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M290.56,236.07,283,231.69c-.61-.36-.54-1,.17-1.38l7.52-4.34a2.62,2.62,0,0,1,2.37-.1l7.59,4.38c.61.36.54,1-.17,1.38L292.93,236A2.62,2.62,0,0,1,290.56,236.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M302.28,242.84l-7.59-4.39c-.61-.35-.54-1,.17-1.37l7.52-4.34a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.35.53,1-.17,1.37l-7.53,4.35A2.65,2.65,0,0,1,302.28,242.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M314,249.6l-7.59-4.38c-.61-.35-.53-1,.17-1.37l7.52-4.34a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.35.53,1-.17,1.37l-7.52,4.34A2.64,2.64,0,0,1,314,249.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M325.72,256.37,318.13,252c-.61-.35-.53-1,.17-1.38l7.52-4.34a2.67,2.67,0,0,1,2.38-.1l7.59,4.39c.61.35.53,1-.17,1.37l-7.52,4.34A2.64,2.64,0,0,1,325.72,256.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M337.44,263.14l-7.59-4.38c-.61-.36-.53-1,.17-1.38l7.52-4.34a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.36.53,1-.17,1.38L339.82,263A2.67,2.67,0,0,1,337.44,263.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M349.16,269.9l-7.59-4.38c-.61-.35-.53-1,.17-1.37l7.52-4.34a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.35.53,1-.17,1.37l-7.52,4.35A2.64,2.64,0,0,1,349.16,269.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M360.88,276.67l-7.59-4.38c-.61-.35-.53-1,.17-1.37l7.52-4.35a2.64,2.64,0,0,1,2.38-.09l7.59,4.38c.61.35.54,1-.17,1.37l-7.52,4.34A2.64,2.64,0,0,1,360.88,276.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M249.22,199l-7.59-4.38c-.61-.36-.53-1,.17-1.38l7.52-4.34a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.36.53,1-.17,1.38l-7.52,4.34A2.64,2.64,0,0,1,249.22,199Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M237.56,192.29,230,187.91c-.61-.35-.54-1,.17-1.37l7.52-4.34a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.35.53,1-.18,1.37l-7.52,4.35A2.62,2.62,0,0,1,237.56,192.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M225.89,185.56l-7.59-4.38c-.61-.35-.53-1,.17-1.37l7.52-4.35a2.67,2.67,0,0,1,2.38-.1l7.59,4.39c.61.35.54,1-.17,1.37l-7.52,4.34A2.64,2.64,0,0,1,225.89,185.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M214.23,178.83l-7.59-4.39c-.61-.35-.53-1,.17-1.37l7.52-4.34a2.64,2.64,0,0,1,2.38-.1L224.3,173c.61.36.53,1-.17,1.38l-7.52,4.34A2.67,2.67,0,0,1,214.23,178.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M226.22,171.9l-7.59-4.38c-.61-.35-.53-1,.17-1.37l2.49-1.44a2.67,2.67,0,0,1,2.38-.1l7.59,4.39c.61.35.53,1-.17,1.37l-2.49,1.43A2.64,2.64,0,0,1,226.22,171.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M241.44,180.69l-7.59-4.38c-.61-.35-.53-1,.17-1.38l2.49-1.43a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.36.53,1-.17,1.38l-2.49,1.43A2.64,2.64,0,0,1,241.44,180.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M253.06,187.4,245.47,183c-.61-.35-.53-1,.17-1.37l2.49-1.43a2.59,2.59,0,0,1,2.37-.1l7.59,4.38c.61.35.54,1-.17,1.37l-2.48,1.44A2.67,2.67,0,0,1,253.06,187.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M264.67,194.1l-7.59-4.38c-.61-.35-.53-1,.17-1.37l2.49-1.44a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.36.53,1-.17,1.38L267.05,194A2.64,2.64,0,0,1,264.67,194.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M276.29,200.81l-7.59-4.39c-.61-.35-.54-1,.17-1.37l2.48-1.43a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.35.53,1-.17,1.37l-2.48,1.44A2.67,2.67,0,0,1,276.29,200.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M341.13,238.24l-7.59-4.38c-.61-.35-.53-1,.17-1.37l2.49-1.44a2.65,2.65,0,0,1,2.37-.1l7.59,4.39c.61.35.54,1-.17,1.37l-2.48,1.43A2.64,2.64,0,0,1,341.13,238.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M352.74,245l-7.59-4.38c-.61-.36-.53-1,.17-1.38l2.49-1.43a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.35.53,1-.17,1.37l-2.49,1.44A2.64,2.64,0,0,1,352.74,245Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M364.36,251.65l-7.59-4.38c-.61-.35-.54-1,.17-1.37l2.48-1.44a2.64,2.64,0,0,1,2.38-.09l7.59,4.38c.61.35.54,1-.17,1.37l-2.48,1.44A2.64,2.64,0,0,1,364.36,251.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M376,258.36,368.38,254c-.61-.35-.53-1,.17-1.38l2.49-1.43a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.35.53,1-.17,1.38l-2.49,1.43A2.64,2.64,0,0,1,376,258.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M260.94,205.79l-7.59-4.38c-.61-.35-.53-1,.17-1.37L261,195.7a2.64,2.64,0,0,1,2.38-.1L271,200c.61.35.53,1-.17,1.37l-7.52,4.35A2.64,2.64,0,0,1,260.94,205.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M272.66,212.56l-7.59-4.38c-.61-.35-.53-1,.17-1.37l7.52-4.34a2.61,2.61,0,0,1,2.38-.1l7.59,4.38c.61.35.53,1-.17,1.37L275,212.46A2.64,2.64,0,0,1,272.66,212.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M284.38,219.33,276.79,215c-.61-.35-.53-1,.17-1.38l7.52-4.34a2.67,2.67,0,0,1,2.38-.1l7.59,4.39c.61.35.54,1-.17,1.37l-7.52,4.34A2.64,2.64,0,0,1,284.38,219.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M296.11,226.1l-7.59-4.39c-.61-.35-.54-1,.17-1.37l7.52-4.34a2.62,2.62,0,0,1,2.37-.1l7.59,4.38c.61.36.54,1-.17,1.38L298.48,226A2.65,2.65,0,0,1,296.11,226.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M307.83,232.86l-7.59-4.38c-.61-.35-.54-1,.17-1.37l7.52-4.34a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.6.35.53,1-.18,1.37l-7.52,4.35A2.62,2.62,0,0,1,307.83,232.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M319.55,239.63,312,235.25c-.61-.35-.54-1,.17-1.37l7.52-4.35a2.64,2.64,0,0,1,2.38-.09l7.59,4.38c.61.35.53,1-.17,1.37l-7.52,4.34A2.64,2.64,0,0,1,319.55,239.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M331.27,246.4,323.68,242c-.61-.36-.53-1,.17-1.38l7.52-4.34a2.67,2.67,0,0,1,2.38-.1l7.59,4.39c.61.35.53,1-.17,1.37l-7.52,4.34A2.64,2.64,0,0,1,331.27,246.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M343,253.17l-7.59-4.39c-.61-.35-.53-1,.17-1.37l7.52-4.34a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.35.53,1-.17,1.38l-7.52,4.34A2.67,2.67,0,0,1,343,253.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M354.71,259.93l-7.59-4.38c-.61-.35-.53-1,.17-1.37l7.52-4.34a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.35.53,1-.17,1.37l-7.52,4.34A2.61,2.61,0,0,1,354.71,259.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M193.93,206.63l-22.35-12.91c-.61-.35-.54-1,.17-1.37l7.52-4.34a2.62,2.62,0,0,1,2.37-.1L204,200.82c.61.35.53,1-.17,1.37l-7.52,4.34A2.64,2.64,0,0,1,193.93,206.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M337.93,289.77l-22.36-12.91c-.61-.35-.53-1,.17-1.37l7.53-4.34a2.62,2.62,0,0,1,2.37-.1L348,284c.61.35.53,1-.17,1.37l-7.52,4.34A2.64,2.64,0,0,1,337.93,289.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M291.05,277.65l-7.59-4.38c-.61-.35-.53-1,.17-1.37l9-5.17a2.64,2.64,0,0,1,2.38-.1l7.59,4.38c.61.35.53,1-.17,1.37l-9,5.17A2.64,2.64,0,0,1,291.05,277.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M205.93,228.51l-12.14-7c-.61-.35-.53-1,.17-1.37l9-5.17a2.64,2.64,0,0,1,2.38-.1l12.14,7c.61.35.53,1-.17,1.37l-9,5.17A2.64,2.64,0,0,1,205.93,228.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M279.76,271.13l-12.14-7c-.61-.35-.53-1,.17-1.37l9-5.17a2.64,2.64,0,0,1,2.38-.1l12.14,7c.61.35.53,1-.17,1.37l-9,5.17A2.64,2.64,0,0,1,279.76,271.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M222.84,238.27l-12.14-7c-.6-.35-.53-1,.18-1.37l9-5.17a2.64,2.64,0,0,1,2.38-.1l12.14,7c.61.35.53,1-.17,1.37l-9,5.17A2.64,2.64,0,0,1,222.84,238.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M222.29,224.67l52.78,30.47a.73.73,0,0,1,0,1.37l-9.14,5.27a2.61,2.61,0,0,1-2.37,0l-52.77-30.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M323.81,289.92l8.46,4.88c.5.29.43.8-.14,1.13l-3.67,2.12a2.2,2.2,0,0,1-1.95.08l-8.45-4.89c-.5-.28-.44-.79.14-1.12l3.66-2.12A2.17,2.17,0,0,1,323.81,289.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M312,283.1l8.46,4.88c.5.29.43.79-.14,1.13l-3.67,2.11a2.17,2.17,0,0,1-1.95.08l-8.45-4.88c-.5-.29-.44-.79.14-1.12l3.66-2.12A2.17,2.17,0,0,1,312,283.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M300.27,276.33l8.46,4.88c.5.29.43.8-.14,1.13l-3.67,2.11a2.18,2.18,0,0,1-1.95.09l-8.45-4.89c-.5-.28-.44-.79.14-1.12l3.66-2.12A2.17,2.17,0,0,1,300.27,276.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M318.47,279.36l8.45,4.88c.5.29.44.8-.14,1.13l-3.66,2.11a2.18,2.18,0,0,1-1.95.09l-8.46-4.89c-.5-.28-.43-.79.14-1.12l3.67-2.12A2.17,2.17,0,0,1,318.47,279.36Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "294.91 75.05 275.84 64.05 276.65 59.94 295.72 70.95 294.91 75.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "292.84 84.59 273.77 73.58 274.59 69.48 293.65 80.49 292.84 84.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "386.41 216.9 367.34 205.89 368.15 201.79 387.22 212.79 386.41 216.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "288.7 103.67 269.64 92.66 270.45 88.56 289.51 99.56 288.7 103.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "369.94 157.32 299.42 116.6 300.33 112.02 370.85 152.74 369.94 157.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "344.69 165.06 295.46 136.63 296.36 132.05 345.59 160.47 344.69 165.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "340.03 151.21 297.44 126.62 298.35 122.03 340.93 146.62 340.03 151.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M331,111.87a2.66,2.66,0,0,1-3.83,1.18,3.32,3.32,0,0,1-1.37-4.18,2.66,2.66,0,0,1,3.83-1.18A3.34,3.34,0,0,1,331,111.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.16,117.16a2.66,2.66,0,0,1-3.83,1.18,3.34,3.34,0,0,1-1.37-4.18,2.66,2.66,0,0,1,3.83-1.18A3.34,3.34,0,0,1,340.16,117.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M349.33,122.46a2.66,2.66,0,0,1-3.83,1.18,3.34,3.34,0,0,1-1.37-4.18,2.66,2.66,0,0,1,3.83-1.18A3.32,3.32,0,0,1,349.33,122.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M358.5,127.75a2.65,2.65,0,0,1-3.82,1.18,3.34,3.34,0,0,1-1.38-4.18,2.66,2.66,0,0,1,3.83-1.18A3.32,3.32,0,0,1,358.5,127.75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "367.96 167.34 346.67 155.04 347.57 150.46 368.87 162.75 367.96 167.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M222.42,291.79l-55.57-32.08c-1.36-.79-1.19-2.16.38-3.06l29.3-16.92a5.92,5.92,0,0,1,5.3-.22l55.56,32.08c1.36.79,1.19,2.16-.38,3.06l-29.3,16.92A5.9,5.9,0,0,1,222.42,291.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "265.91 322.08 115.39 235.28 159.26 209.95 309.78 296.75 265.91 322.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.91,302.1a2.29,2.29,0,0,1-1.16-.31L114.23,215a2.32,2.32,0,0,1,0-4l43.87-25.32a2.29,2.29,0,0,1,2.32,0l150.52,86.8a2.32,2.32,0,0,1,0,4l-43.87,25.32A2.29,2.29,0,0,1,265.91,302.1ZM120,213l145.88,84.13,39.23-22.65L159.26,190.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M185.61,230.79a1.86,1.86,0,0,1-1.86-1.86V170.18a1.86,1.86,0,1,1,3.72,0v58.75A1.86,1.86,0,0,1,185.61,230.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M176.42,163.52v39.69h0c0,1.36.89,2.72,2.69,3.76a14.4,14.4,0,0,0,13,0c1.79-1,2.69-2.4,2.69-3.76V163.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M176.42,170.05v13.43a23.75,23.75,0,0,0,18.39,0V170.05A23.75,23.75,0,0,0,176.42,170.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M200.52,108.2H170.71v62.25h0c0,2.21,1.45,4.41,4.36,6.09,5.82,3.36,15.26,3.36,21.08,0,2.91-1.68,4.37-3.88,4.37-6.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M183,197.18c0,1.82-1.28,2.56-2.86,1.65a6.32,6.32,0,0,1-2.86-5c0-1.82,1.28-2.56,2.86-1.65A6.32,6.32,0,0,1,183,197.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M243.41,264.2a1.86,1.86,0,0,1-1.86-1.86V203.59a1.86,1.86,0,0,1,3.72,0v58.75A1.86,1.86,0,0,1,243.41,264.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M234.21,196.93v39.69h0c0,1.36.9,2.72,2.7,3.76a14.38,14.38,0,0,0,13,0c1.8-1,2.7-2.4,2.7-3.76V196.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M234.21,203.46v13.43a23.77,23.77,0,0,0,18.4,0V203.46A23.77,23.77,0,0,0,234.21,203.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M258.31,141.61h-29.8v62.25h0c0,2.2,1.45,4.41,4.36,6.09,5.82,3.36,15.26,3.36,21.08,0,2.91-1.68,4.36-3.89,4.36-6.09h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M240.83,230.59c0,1.82-1.28,2.56-2.86,1.65a6.33,6.33,0,0,1-2.87-5c0-1.82,1.29-2.56,2.87-1.65A6.32,6.32,0,0,1,240.83,230.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M128.49,63.13l39.56-22.76s-1.49,22.72-1.49,22.76-22.73,7-22.73,7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M340.44,194.15c0-16-11.22-35.4-25.05-43.39a25,25,0,0,0-8.57-3.17c-4-21-18.57-43.23-36-53.27a35.25,35.25,0,0,0-14.72-5c-2.37-25.41-20-54.29-41.5-66.67-11.21-6.47-21.37-7.24-28.88-3.28v0l-.36.21-.57.33L161.49,33.68l7.75,6.12c-7,3-11.36,10.85-11.36,22.39,0,21.27,14.94,47.14,33.37,57.78L305,201.19l3.5,23.67,24.58-14.48.07,0,.15-.09h0C337.71,207.59,340.44,202,340.44,194.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M159,52.82l53.55-31.29c-10.39-5.42-19.78-5.87-26.83-2.15v0l-.36.21-.57.33L161.49,33.68l7.75,6.12C164.38,41.93,160.77,46.39,159,52.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M257.93,144.86,297,121.93c-6.7-11.59-15.93-21.72-26.15-27.61a43.5,43.5,0,0,0-4-2.06l-49.69,29.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M172.5,36.24l17.41,10L221.8,27.51a62.74,62.74,0,0,0-7.17-4.85A44.47,44.47,0,0,0,203.49,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M292.69,115.18,261.5,133.56l10.85,12.1,28.31-16.72A91.51,91.51,0,0,0,292.69,115.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M290.89,165.19a24.91,24.91,0,0,0-8.56-3.17c-4-21-18.58-43.23-36-53.27a35.15,35.15,0,0,0-14.72-5c-2.38-25.41-20-54.29-41.5-66.67-23.08-13.33-41.78-2.53-41.78,24.12,0,.9,0,1.81.07,2.73-16.88-7.83-30.06,1-30.06,21,0,21.27,14.93,47.14,33.36,57.78L290.89,223c13.84,8,25.05,1.52,25.05-14.46S304.73,173.18,290.89,165.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M148.43,63.94c-.05-.92-.07-1.83-.07-2.73v-.12C139,57.47,131,59.05,126,64.86,131.46,60.37,139.4,59.75,148.43,63.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.93,163.2a25.12,25.12,0,0,0-8.56-3.17c-4-21-18.58-43.23-36-53.27a35.22,35.22,0,0,0-14.72-5c-2.37-25.41-20-54.29-41.5-66.68-14.37-8.3-27-7.23-34.57,1.19,7.66-6.55,19.39-6.8,32.54.8,21.45,12.38,39.12,41.26,41.5,66.67a35.15,35.15,0,0,1,14.72,5c17.39,10,32,32.3,36,53.27a24.91,24.91,0,0,1,8.56,3.17c13.84,8,25.05,27.42,25.05,43.39,0,5.77-1.47,10.27-4,13.33,3.75-2.89,6-8.13,6-15.31C318,190.62,306.76,171.19,292.93,163.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M145.48,70.28l10.46,4.85-.53-11.51c0-.81-.06-1.62-.06-2.41,0-10.29,3.1-17.74,8.74-21s13.65-2.21,22.55,2.93c19.15,11.06,35.86,38,38,61.27l.55,5.88,5.88.45a28.18,28.18,0,0,1,11.76,4.06c15.21,8.78,28.92,29.19,32.6,48.52l.92,4.84,4.87.77a17.92,17.92,0,0,1,6.14,2.32C299.08,178,309,195.09,309,208.58c0,5-1.4,8.75-3.84,10.16s-6.35.77-10.72-1.75L155.23,136.64c-16.19-9.34-29.87-33-29.87-51.72,0-7.34,2.17-12.93,5.94-15.34a10.15,10.15,0,0,1,5.54-1.48A20.94,20.94,0,0,1,145.48,70.28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "214.94 157.5 218.61 155.66 214.99 152.92 214.94 157.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "203.91 107.91 207.47 106.11 207.54 107.97 203.91 107.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "225.41 145.91 229.13 144.04 221.97 137.23 225.41 145.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M217.53,155.54,200.15,145.3a3.72,3.72,0,0,1-1.59-2.92l.06-20.12,20.57,12.12-.05,20.12C219.13,155.59,218.41,156.06,217.53,155.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M207.44,106.13l-18.78,12.08c-.79.51-.15,2.42,1.06,3.13l19.17,11.3,19.17,11.29c1.21.71,1.87-.44,1.08-1.89l-18.65-34.11C209.69,106.46,208.25,105.61,207.44,106.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M213.81,157.42l-17.38-10.24a3.7,3.7,0,0,1-1.6-2.92l.06-20.12,20.58,12.11-.06,20.12C215.41,157.47,214.69,157.93,213.81,157.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M203.71,108l-18.77,12.08c-.8.51-.16,2.42,1.05,3.13l19.18,11.29,19.17,11.29c1.21.72,1.86-.43,1.07-1.88l-18.64-34.11C206,108.33,204.52,107.49,203.71,108Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtivo3);
export default __webpack_public_path__ + "static/media/ativo-3.a1802dae93021019bb3975ee999ee455.svg";
export { ForwardRef as ReactComponent };